import {Injectable} from '@angular/core';
import {ApiRouteConfig} from "../../../config/api.route.config";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {InterventionTeamDetailDto} from "./teams/intervention-team-detail.dto";
import {PaginationResponse} from "../../common/model/pagination-response";
import {InterventionTeamContactDto} from "./contacts/intervention-team-contact.dto";
import {map} from "rxjs/operators";
import {BuildingSummary} from "../../common/model/building-summary";


@Injectable()
export class InterventionTeamResource {
  private readonly endpoint = this.api.MAINTENANCE_INTERVENTION_TEAMS;
  constructor(
    private readonly api: ApiRouteConfig,
    private readonly http: HttpClient,
  ) {
  }

  public all(): Observable<PaginationResponse<InterventionTeamDetailDto>> {
    return this.http.get<PaginationResponse<InterventionTeamDetailDto>>(`${this.endpoint}/all`);
  }

  public find(where: InterventionTeamsQuery) {
    return this.http.post<PaginationResponse<InterventionTeamDetailDto>>(
      `${this.endpoint}/search`,
      where,
    );
  }

  public get(teamGuid: string): Observable<InterventionTeamDetailDto> {
    return this.http.get<InterventionTeamDetailDto>(`${this.endpoint}/${teamGuid}`);
  }

  public update(team: InterventionTeamDetailDto | InterventionTeamDetailDto): Observable<InterventionTeamDetailDto> {
    return this.http.put<InterventionTeamDetailDto>(`${this.endpoint}`, team);
  }

  public create(team: InterventionTeamDetailDto): Observable<InterventionTeamDetailDto> {
    return this.http.post<InterventionTeamDetailDto>(this.endpoint, team);
  }

  public delete(team: InterventionTeamDetailDto): Observable<undefined> {
    return this.http.delete<undefined>(`${this.endpoint}/${team.id}`);
  }

  public assign(contact: InterventionTeamContactDto, team: InterventionTeamDetailDto): Observable<undefined> {
    return this.http.post<undefined>(`${this.endpoint}/${team.id}/contact/${contact.id}`, '');
  }

  public unassign(team: InterventionTeamDetailDto, contact: InterventionTeamContactDto): Observable<InterventionTeamContactDto> {
    return this.http.delete(`${this.endpoint}/${team.id}/contact/${contact.id}`).pipe(
      map(() => contact),
    );
  }

  public addBuilding(building: BuildingSummary, team: InterventionTeamDetailDto): Observable<BuildingSummary> {
    return this.http.post(`${this.endpoint}/${team.id}/building/${building.guid}`, building).pipe(
      map(() => building),
    )
  }

  public removeBuilding(building: BuildingSummary, team: InterventionTeamDetailDto): Observable<BuildingSummary> {
    return this.http.delete(`${this.endpoint}/${team.id}/building/${building.guid}`).pipe(
      map(() => building)
    );
  }
}

export interface InterventionTeamsQuery {
  contactId?: string;

  [index: string]: any;
}
